import React from "react"

export default class FormFooterLinks extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="row">
				<div className="col-sm-12">
					{
						this.props.left
						?
						<div className="pull-left">
							<a href={this.props.left.path}>{this.props.left.text}</a>
						</div>
						:
						null
					}
					{
						this.props.right
						?
						<div className="pull-right">
							<a href={this.props.right.path}>{this.props.right.text}</a>
						</div>
						:
						null
					}
				</div>
			</div>
		);	
	}

}